import _classCallCheck from "/home/runner/work/spa-manager/spa-manager/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/spa-manager/spa-manager/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/spa-manager/spa-manager/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/spa-manager/spa-manager/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/home/runner/work/spa-manager/spa-manager/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/runner/work/spa-manager/spa-manager/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _pt from "prop-types";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Nav/nav';
import { css } from '@patternfly/react-styles';
export var NavContext = React.createContext({});
export var Nav =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Nav, _React$Component);

  function Nav() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Nav);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Nav)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      showLeftScrollButton: false,
      showRightScrollButton: false
    });

    _defineProperty(_assertThisInitialized(_this), "updateScrollButtonState", function (state) {
      var showLeftScrollButton = state.showLeftScrollButton,
          showRightScrollButton = state.showRightScrollButton;

      _this.setState({
        showLeftScrollButton: showLeftScrollButton,
        showRightScrollButton: showRightScrollButton
      });
    });

    return _this;
  } // Callback from NavItem


  _createClass(Nav, [{
    key: "onSelect",
    value: function onSelect(event, groupId, itemId, to, preventDefault, onClick) {
      if (preventDefault) {
        event.preventDefault();
      }

      this.props.onSelect({
        groupId: groupId,
        itemId: itemId,
        event: event,
        to: to
      });

      if (onClick) {
        onClick(event, itemId, groupId, to);
      }
    } // Callback from NavExpandable

  }, {
    key: "onToggle",
    value: function onToggle(event, groupId, toggleValue) {
      this.props.onToggle({
        event: event,
        groupId: groupId,
        isExpanded: toggleValue
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          ariaLabel = _this$props['aria-label'],
          children = _this$props.children,
          className = _this$props.className,
          onSelect = _this$props.onSelect,
          onToggle = _this$props.onToggle,
          theme = _this$props.theme,
          props = _objectWithoutProperties(_this$props, ["aria-label", "children", "className", "onSelect", "onToggle", "theme"]);

      var _this$state = this.state,
          showLeftScrollButton = _this$state.showLeftScrollButton,
          showRightScrollButton = _this$state.showRightScrollButton;
      var childrenProps = children.props;
      return React.createElement(NavContext.Provider, {
        value: {
          onSelect: function onSelect(event, groupId, itemId, to, preventDefault, onClick) {
            return _this2.onSelect(event, groupId, itemId, to, preventDefault, onClick);
          },
          onToggle: function onToggle(event, groupId, expanded) {
            return _this2.onToggle(event, groupId, expanded);
          },
          updateScrollButtonState: this.updateScrollButtonState
        }
      }, React.createElement("nav", _extends({
        className: css(styles.nav, theme === 'dark' && styles.modifiers.dark, showLeftScrollButton && styles.modifiers.start, showRightScrollButton && styles.modifiers.end, className),
        "aria-label": ariaLabel === '' ? typeof childrenProps !== 'undefined' && childrenProps.variant === 'tertiary' ? 'Local' : 'Global' : ariaLabel
      }, props), children));
    }
  }]);

  return Nav;
}(React.Component);

_defineProperty(Nav, "propTypes", {
  children: _pt.node,
  className: _pt.string,
  onSelect: _pt.func,
  onToggle: _pt.func,
  'aria-label': _pt.string,
  theme: _pt.oneOf(['dark', 'light'])
});

_defineProperty(Nav, "defaultProps", {
  'aria-label': '',
  "children": null,
  "className": '',
  "onSelect": function onSelect() {
    return undefined;
  },
  "onToggle": function onToggle() {
    return undefined;
  },
  "theme": 'light'
});